import { Typography } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

export const Title: FC<PropsWithChildren> = ({ children }) => {
  return <Typography variant="h2">{children}</Typography>;
};

export const Body1: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Typography variant="body1" my={3}>
      {children}
    </Typography>
  );
};
